"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateReportTemplateFailure = exports.updateReportTemplateSuccess = exports.updateReportTemplateValidation = exports.updateReportTemplateRequest = void 0;
const UpdateReportActionTypes = require("../../actionTypes/reports/update");
const updateReportTemplateRequest = (customerId, templateUuid, payload) => ({
    type: UpdateReportActionTypes.UPDATE_REPORT_TEMPLATE_REQUEST,
    customerId,
    templateUuid,
    payload
});
exports.updateReportTemplateRequest = updateReportTemplateRequest;
const updateReportTemplateValidation = (errors) => ({
    type: UpdateReportActionTypes.UPDATE_REPORT_TEMPLATE_VALIDATION,
    errors
});
exports.updateReportTemplateValidation = updateReportTemplateValidation;
const updateReportTemplateSuccess = () => ({
    type: UpdateReportActionTypes.UPDATE_REPORT_TEMPLATE_SUCCESS
});
exports.updateReportTemplateSuccess = updateReportTemplateSuccess;
const updateReportTemplateFailure = (error) => ({
    type: UpdateReportActionTypes.UPDATE_REPORT_TEMPLATE_FAILURE,
    error
});
exports.updateReportTemplateFailure = updateReportTemplateFailure;
//# sourceMappingURL=update.js.map